import { isbot } from 'isbot'

export default defineNuxtPlugin(() => {
  const isCrawler = useState<boolean>('isCrawler', () => false)

  if (import.meta.server) {
    const event = useRequestEvent()
    const userAgent = event?.node.req.headers['user-agent'] || ''

    isCrawler.value = isbot(userAgent)
  } else {
    isCrawler.value = isbot(window.navigator.userAgent)
  }

  return {
    provide: {
      isCrawler,
    },
  }
})
